<template>
    <div class="panelisttooltip">
        <v-row>
            <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align"></v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <DatePicker label="Date" :date="panelist.pp_date" @choose="chooseDate" :disable_future="true"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align"></v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field label="Invitation ID" outlined dense v-model="panelist.invitation_id"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align"></v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field label="Last 4 Digits" outlined dense v-model="panelist.tracking_id"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align"></v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field label="Panelist" outlined dense v-model='fetchpanelist'/>
                <div id="panelisttooltip__tooltip" v-if="allpanelist.length > 0">
                    <ul id="panelisttooltip__tooltip--list">
                        <li v-for="(p, i) in allpanelist" v-bind:key="i" v-ripple="{ class: `primary--text` }" @click.prevent="choosePanelist(p)">
                            <span v-if="isAlreadyExists(p)">*</span>{{ p.competi_id }} ({{ p.name }}) / {{state_abb(p)}}
                        </li>
                    </ul>
                </div>
            </v-col>
            <v-col :cols="3" class="text-left no-right no-bottom no-top">
                <v-progress-circular
                            :width="3"
                            :size="20"
                            color="primary"
                            indeterminate
                            v-if="showSpinner"
                            >
                </v-progress-circular>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="3"></v-col>
            <v-col :cols="6">
                <v-btn small color="primary" @click.prevent="close()">Close</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import DatePicker from './../../utilities/DatePicker'
import { mapGetters } from 'vuex'
export default {
    name: 'ProductTooltip',
    data: () => ({
        fetchpanelist:'',
        allpanelist: [],
        showSpinner:false,
        panelist: {
            pp_date: '',
            competi_id: '',
            invitation_id: '',
            panelist_id: '',
            tracking_id: '',
            age: '',
            gender: '',
            incomeID: '',
            stateID: '',
            name:'',
        }
    }),
    mounted() {
        let panelists = this.$store.getters["ProductData/getPanelists"]
        if(panelists.length > 0 ){
            let last_panelist = panelists[panelists.length-1]
            this.panelist.pp_date = last_panelist.pp_date
        }
    },
    components: {
        DatePicker
    },
    computed: {
        ...mapGetters({
            state_specific: 'ProductData/getStateSpecific',
        })
    },
    methods: {
        state_abb: function (p) {
            let state_name = ''
            let raw_states = this.$store.getters["ProductData/getRawProductStates"]
            if(raw_states.length){
                raw_states.forEach((rs) => {
                    if(rs.stateID == p.stateID){
                        state_name = rs.stateCode
                    }
                })
            }
            return state_name
            
        },
        chooseDate: function(d) {
            this.panelist.pp_date = d
        },
        close: function() {
            this.$emit('closePanelist', false)
            this.$emit('editDate');
            var array = [];
            if(this.$store.getters["ProductData/getPanelists"].length > 0){
                for(let i =0; i<this.$store.getters["ProductData/getPanelists"].length;i++){
                array.push(this.$store.getters["ProductData/getPanelists"][i].pp_date)
                }
                array.sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
                this.$store.dispatch("ProductData/setEntryDate", array[0]);

            }
        },
        
        choosePanelist: function(p) {
            if (this.panelist.pp_date === '' || typeof this.panelist.pp_date === 'undefined') {
                alert('Please choose date.')
            } else {
                if (typeof p.competi_id !== 'undefined' && typeof p.panelist_id !== 'undefined') {
                    this.panelist.competi_id = p.competi_id
                    this.panelist.panelist_id = p.panelist_id
                    this.panelist.age = p.age
                    this.panelist.gender = p.gender
                    this.panelist.incomeID = p.incomeID
                    this.panelist.stateID = p.stateID
                    this.panelist.name = p.name
                    console.log(p);
                    this.allpanelist = []
                    let state_different = []
                    if (this.isAlreadyExists(p)) {
                    this.$swal.fire({
                        position: "bottom-end",
                        icon: "error",
                        title: "Panelist already selected!",
                        });
                    }
                    else if (this.state_specific === true) {
                        let selected_panelists = this.$store.getters["ProductData/getPanelists"];
                        
                        if(selected_panelists.length){
                           selected_panelists.forEach((o)=>{
                               console.log(o.stateID, p.stateID)
                               if(o.stateID ==0 || p.stateID ==0) return;

                               if(o.stateID != p.stateID){
                                   state_different.push(1)
                               }
                           }) 
                        }
                        if(state_different.length == 0){
                           this.setPanelist(this.panelist)
                           state_different = []
                        }else{
                            this.$swal.fire({
                            position: "bottom-end",
                            icon: "error",
                            title: "Panelist of different states are not allowed when state specific is checked!",
                            });
                        }
                    } else {
                        this.setPanelist(this.panelist)
                    }
                    
                }
            }
        },
        setPanelist: function(p) {
            var view = this
             view.$store.dispatch('ProductData/setProductPanelists', p).then(function() {
                view.close()
            })
            // set state province
            let selected_states = this.$store.getters["ProductData/getStateProvince"];
            // PATCH added for JIRAID-3335
            if(!selected_states.includes(p.stateID) && p.stateID != 0){
                selected_states.push(p.stateID)
                this.$store.dispatch("ProductData/setStateProvince", []);
                this.$store.dispatch("ProductData/setStateProvince", selected_states);
            }
                // set product age as per panelist age
            if(p.age != null && p.age != ''){
                let product_age = this.$store.getters["ProductData/getProductAge"];
                if(!product_age.includes(p.age)){
                        product_age.push(p.age)
                        this.$store.dispatch("ProductData/setProductAge", []);
                        this.$store.dispatch("ProductData/setProductAge", product_age);
                    }
            }
            // set product income as per panelist
            if(p.incomeID != '' && p.incomeID != null){
                let product_income = this.$store.getters["ProductData/getProductIncome"];
                if(!product_income.includes(p.incomeID)){
                        product_income.push(p.incomeID)
                        this.$store.dispatch("ProductData/setProductIncome", []);
                        this.$store.dispatch("ProductData/setProductIncome", product_income);
                    }
            }
            // set product gender as per panelist
            if(p.gender != '' && p.gender != null){
                let both_gender = []
                //let product_gender = this.$store.getters["ProductData/getGender"];
                let selected_panelists = this.$store.getters["ProductData/getPanelists"];
        
                if(selected_panelists.length){
                selected_panelists.forEach((o)=>{
                    if(o.gender != "" && o.gender != p.gender){
                        both_gender.push(1)
                    }
                }) 
                if(both_gender.length > 0){
                    this.$store.dispatch("ProductData/setGender", '');
                        this.$store.dispatch("ProductData/setGender", "B");
                }else{
                    this.$store.dispatch("ProductData/setGender", 'N');
                    this.$store.dispatch("ProductData/setGender", p.gender); 
                }
                }else{
                    this.$store.dispatch("ProductData/setGender", 'N');
                    this.$store.dispatch("ProductData/setGender", p.gender); 
                }
                both_gender = []
            }
            
            
        },
        isAlreadyExists: function(p) {
            let view = this,
                pans = view.$store.getters['ProductData/getPanelists']
            return pans.find(o => (o.competi_id === p.competi_id && o.panelist_id === p.panelist_id))
        }
    },
    watch: {
        fetchpanelist: function(v) {
            var view = this
            if (v.length > 1) {
                 setTimeout(()=>{
                        view.showSpinner = true
                    },1000)
                view.$fetch({
                    url: view.$url('API') + 'panelists/' + v,
                    type: 'GET',
                },{
                operation: 'view',
                vueScope: view
            }).then(function(response) {
                    //view.showSpinner = false
                    setTimeout(()=>{
                        view.showSpinner = false
                    },500)
                    view.allpanelist = []
                    if (response.length > 0) {
                        response.forEach(function(o) {
                            view.allpanelist.push({
                                competi_id: o.competi_id,
                                name: o.first_name + " " + o.last_name,
                                panelist_id: o.panelist_id,
                                age: Math.floor(o.age/10),
                                gender: o.gender,
                                incomeID: o.incomeID,
                                stateID: o.stateID,
                            })
                        })
                    }
                }).catch(e => console.log(e),view.showSpinner = false)
            }else{
                view.allpanelist = []
                view.showSpinner = false
            }
        }
    }
}
</script>

<style scoped lang="sass">
@import './../../assets/sass/product/producttooltip'
.v-progress-circular
    top:25%
</style>